import React from 'react';
import EasypayConfiguration from './Easypay/ConfigurationForm';
import EpayConfiguration from './Epay/ConfigurationForm';
import PayPalConfiguration from './PayPal/ConfigurationForm';
import SaferpayConfiguration from './Saferpay/ConfigurationForm';
import BankTransferConfiguration from './BankTransfer/ConfigurationForm';
import StripeConfiguration from './Stripe/ConfigurationForm';
import { GoCardlessConfiguration } from './GoCardless';
import InStoreConfiguration from './InStore/ConfigurationForm';
import VoucherConfiguration from './Voucher/ConfigurationForm';
import CloverConnectConfiguration from './CloverConnect/ConfigurationForm';
import PonchoPayConfiguration from './PonchoPay/ConfigurationForm';
import TakePaymentsConfiguration from './TakePayments/ConfigurationForm';

export const paymentOwners = { franchisor: 1, franchisee: 2, center: 3 };

export const getLocationPathByPaymentOwner = (paymentOwnerType, paymentOwnerId, franchiseeId) => {
	let pathname = '';

	switch (paymentOwnerType) {
		case paymentOwners.franchisor:
			pathname = '/settings/payments';
			break;
		case paymentOwners.franchisee:
			pathname = `/franchisees/${paymentOwnerId}/payments`;
			break;
		case paymentOwners.center:
			pathname = `/franchisees/${franchiseeId}/centers/${paymentOwnerId}`;
			break;
	}

	return pathname;
}

export const methods = {
	PAYPAL: 'PayPalExpress',
	EASYPAY: 'Easypay',
	EPAY: 'Epay',
	SAFERPAY: 'Saferpay',
	BANK_TRANSFER: 'BankTransfer',
	STRIPE: 'Stripe',
	GOCARDLESS: 'GoCardless',
	IN_STORE: 'InStore',
	VOUCHER: 'Voucher',
	CLOVER_CONNECT: 'CloverConnect',
	PONCHOPAY: 'PonchoPay',
	TAKEPAYMENTS: 'Takepayments'
};

export const configurationComponent = (method, configurationValues, props) => {
	switch (method) {
		case methods.PAYPAL:
			return <PayPalConfiguration {...props} />;
		case methods.EASYPAY:
			return <EasypayConfiguration {...props} />;
		case methods.EPAY:
			return <EpayConfiguration {...props} />;
		case methods.SAFERPAY:
			return <SaferpayConfiguration {...props} />;
		case methods.BANK_TRANSFER:
			return <BankTransferConfiguration {...props} />;
		case methods.STRIPE:
			return <StripeConfiguration configurationValues={configurationValues} {...props} />;
		case methods.GOCARDLESS:
			return <GoCardlessConfiguration configurationValues={configurationValues} {...props} />;
		case methods.IN_STORE:
			return <InStoreConfiguration {...props} />
		case methods.VOUCHER:
			return <VoucherConfiguration {...props} />
		case methods.CLOVER_CONNECT:
			return <CloverConnectConfiguration {...props} />;
		case methods.PONCHOPAY:
			return <PonchoPayConfiguration {...props} />;
		case methods.TAKEPAYMENTS:
			return <TakePaymentsConfiguration {...props} />;
	}
};

export const configurationValues = (method, data) => {
	let defaultValues = {};

	switch (method) {
		case methods.PAYPAL:
			defaultValues = { paymentAction: 'Sale' };
			break;
	}

	const configValues = data && data.configurationJson && JSON.parse(data.configurationJson);

	return {
		enabled: data && data.enabled,
		hiddenForParents: data && data.hiddenForParents,
		enableOneOffPayments: data && data.enableOneOffPayments,
		enableRecurringPayments: data && data.enableRecurringPayments,
		...defaultValues, ...configValues
	};
};